module.exports = __webpack_public_path__ + "img/music-note-beamed.4d57dbac.svg";